import sidebarSlice from "config/slice/sidebar";
import waV1UserApi from "config/api/waV1_user";
import messageSlice from "config/slice/message";
import waV1FileApi from "config/api/waV1_file";
const { configureStore } = require("@reduxjs/toolkit");
const { default: globalSlice } = require("config/slice/global");


const store = configureStore({
    reducer: {
        global: globalSlice.reducer,
        sidebar: sidebarSlice.reducer,
        message: messageSlice.reducer,

        [waV1UserApi.reducerPath]: waV1UserApi.reducer,
        [waV1FileApi.reducerPath]: waV1FileApi.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        // serializableCheck: false
    }).concat(waV1UserApi.middleware).concat(waV1FileApi.middleware)
})

export default store